import Vuex from 'vuex'
import Vue from 'vue'
// import feed from './modules/feed'
import profile from './modules/profile'
import campaign from './modules/influencer/campaign'
import contentNotes from './modules/influencer/contentNotes'
import earnings from './modules/influencer/earnings'

// Components
import DialogChangeStatus from './modules/components/CampaignContents/DialogChangeStatus'
import DialogContentNote from './modules/components/CampaignContents/DialogContentNote'
import DialogDeleteContentNote from './modules/components/CampaignContents/DialogDeleteContentNote'

// Load Vuex
Vue.use(Vuex)

// CREATE STORE 
export default new Vuex.Store({
  modules: {
    // feed,
    profile,
    campaign,
    contentNotes,
    earnings,
    // Components
    DialogChangeStatus,
    DialogContentNote,
    DialogDeleteContentNote
  }
})